import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IppsMedicareReferenceData } from '@app/shared/models/contract.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

export const routes = {
  aprDrgCodes: (startDate) =>
    `${environment.api.globalServiceBaseURL}GlobalReference/external/apr-drg?startDate=${startDate}`,
  msDrgCodes: (medicareRefId: number) =>
    `${environment.api.globalServiceBaseURL}IppsMedicareReference/Drgcmsschedule/${medicareRefId}/false/false`,
  latestIppsMedicareRefId: () => `${environment.api.globalServiceBaseURL}IppsMedicareReference/LatestMedicareReference`,
};

const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  constructor(private readonly http: HttpClient) {}

  getLatestIppsMedicareRefId(): Observable<IppsMedicareReferenceData> {
    return this.http.get<any>(routes.latestIppsMedicareRefId(), { headers });
  }
}
